import { getEventOccurrenceKey } from '../../../utils/eventOccurrenceKey';

export const STORAGE_KEY = 'artist_event_list_state_v1';
export const SCROLL_KEY = 'artist_event_list_scrollY';
export const PAGE_SIZE_KEY = 'artist_event_list_page_size';
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = 20;
export const FETCH_LIMIT_MULTIPLIER = 10;
export const FILTER_TTL_MS = 3 * 24 * 60 * 60 * 1000;

export const AUTO_RANGE_LABELS = {
  auto: '期間選択',
  today: '今日',
  last7: '過去7日',
  last30: '過去30日',
  thisWeek: '今週',
  thisMonth: '今月',
  nextMonth: '来月',
  lastYear: '昨年',
  thisYear: '今年',
  nextYear: '翌年',
};

export const fmtDate = (d) => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const setCookie = (name, value, days = 365) => {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
};

export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  if (match) return match[2];
  return null;
};

export const isToday = (yyyyMmDd) => {
  if (!yyyyMmDd || typeof yyyyMmDd !== 'string') return false;
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth() + 1;
  const d = now.getDate();
  const [ey, em, ed] = yyyyMmDd.split('-').map((n) => parseInt(n, 10));
  return y === ey && m === em && d === ed;
};

const parsePgIntArray = (s) => {
  const t = String(s || '').trim();
  if (t.startsWith('{') && t.endsWith('}')) {
    return t.slice(1, -1).split(',').map((x) => Number(x)).filter(Number.isInteger);
  }
  return null;
};

export const normalizeGenreIds = (maybeGenre) => {
  if (Array.isArray(maybeGenre)) {
    return maybeGenre.map((v) => Number(v)).filter((n) => Number.isInteger(n));
  }
  if (typeof maybeGenre === 'string' && maybeGenre.trim().startsWith('{')) {
    return parsePgIntArray(maybeGenre) || [];
  }
  if (typeof maybeGenre === 'string' && maybeGenre.trim().startsWith('[')) {
    try {
      const arr = JSON.parse(maybeGenre);
      if (Array.isArray(arr)) {
        return arr.map((v) => Number(v)).filter((n) => Number.isInteger(n));
      }
    } catch {}
  }
  if (typeof maybeGenre === 'number') return [Number(maybeGenre)];
  if (typeof maybeGenre === 'string' && maybeGenre) return [maybeGenre];
  return [];
};

export const normalizeSelectionValue = (value) => {
  if (value === null || value === undefined) return '';
  return String(value);
};

export const normalizeSelectionArray = (values) => {
  if (!Array.isArray(values)) return [];
  return values
    .map((val) => normalizeSelectionValue(val))
    .filter((val) => val !== '');
};

export function dedupeAndMergeStatuses(list = []) {
  const map = new Map();
  for (const ev of list) {
    const key = getEventOccurrenceKey(ev);
    if (!key) continue;
    const offerArr = Array.isArray(ev.offer_statuses) ? ev.offer_statuses : (ev.offerStatuses || []);
    const contractArr = Array.isArray(ev.contract_statuses) ? ev.contract_statuses : (ev.contractStatuses || []);
    if (!map.has(key)) {
      map.set(key, {
        ...ev,
        offer_statuses: [...new Set(offerArr || [])],
        contract_statuses: [...new Set(contractArr || [])],
      });
      continue;
    }
    const prev = map.get(key);
    map.set(key, {
      ...prev,
      ...ev,
      offer_statuses: [...new Set([...(prev.offer_statuses || []), ...(offerArr || [])])],
      contract_statuses: [...new Set([...(prev.contract_statuses || []), ...(contractArr || [])])],
    });
  }
  return Array.from(map.values());
}
